"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivisionId = void 0;
/**
 * This enum maps the energy type to a division id used in both SAP and GDS
 */
var DivisionId;
(function (DivisionId) {
    DivisionId["ELECTRICITY"] = "01";
    DivisionId["GAS"] = "02";
})(DivisionId = exports.DivisionId || (exports.DivisionId = {}));
